// 参照専用の埋め込みモード判定。
//
// Connect Note などの外部アプリが RC のキャンバスを iframe で「参照専用」表示するとき、
// URL に `?embed=1` を付けて `/c/:canvasId` を開く。埋め込みモードでは通常の OIDC リダイレクト
// 認証を行わず、親フレームから postMessage で渡されるトークンで API を呼ぶ（embed-auth.ts）。
//
// 判定は同期関数として提供し、React の初回 render・認証ブートストラップの前段で評価できるようにする。

/** `/c/:canvasId` パスのみ（canvasId は router.tsx と同じ規則）。 */
const CANVAS_PATH_PATTERN = /^\/c\/[A-Za-z0-9_-]{6,64}\/?$/u;

/**
 * 現在の URL が参照専用の埋め込みモードかどうかを返す。
 * `?embed=1` かつ `/c/:canvasId` パスのときのみ true（ダッシュボード等での誤判定を防ぐ）。
 */
export function isEmbedMode(): boolean {
  if (typeof window === "undefined" || window.location === undefined) {
    return false;
  }
  const { pathname, search } = window.location;
  if (!CANVAS_PATH_PATTERN.test(pathname)) {
    return false;
  }
  return new URLSearchParams(search).get("embed") === "1";
}
